<template>
  <router-link class="ncrm-privacy-purpose-link text-body-2" :to="target">
    <v-icon size="16" class="me-1">{{ canManage ? "mdi-cog-outline" : "mdi-eye-outline" }}</v-icon>
    {{ $t(`ncrm.contacts.dataProtection.workspace.purposes.link.${canManage ? "manage" : "view"}`) }}
  </router-link>
</template>

<script>
import { hasPrivacyManagerRole } from "@/Utile/ncrmPrivacyAccess.mjs";
import { purposesRoute } from "./privacyPurposeModel.mjs";

// Linkul contextual spre proprietarul canonic al scopurilor (`docs/design.md` →
// `Configurare ușor de găsit`). Managerul vede `Gestionează scopurile`; celelalte
// roluri din registru văd secțiunea read-only (`Vezi scopurile`), deci linkul nu
// duce niciodată într-un 403. `returnTo` readuce utilizatorul în contextul sursă.
export default {
  name: "NcrmPrivacyPurposeLink",
  props: {
    purposeId: { type: [Number, String], default: null },
    returnTo: { type: String, default: null },
  },
  data: () => ({ canManage: false }),
  computed: {
    target() { return purposesRoute({ returnTo: this.returnTo || this.$route?.fullPath, purposeId: this.purposeId }); },
  },
  created() { this.canManage = hasPrivacyManagerRole(); },
};
</script>

<style scoped>
.ncrm-privacy-purpose-link { display: inline-flex; align-items: center; color: rgb(var(--v-theme-primary)); text-decoration: none; }
.ncrm-privacy-purpose-link:hover { text-decoration: underline; }
</style>
